/**
 * Monetization config.
 *
 * ADSGRAM_BLOCK_ID — paste your Adsgram "Block ID" between the quotes below.
 *   1. Go to https://adsgram.ai and sign in with Telegram.
 *   2. Add your bot (@kakakalpobot) and connect a TON wallet for payouts.
 *   3. Create a "Reward" ad block — it gives you a Block ID like "int-1234".
 *   4. Paste that ID here and redeploy.
 *
 * While this is empty, the in-game "watch ad for gold" button still works in
 * testing (it grants the reward without showing a real ad), so the game is
 * never blocked — but you only EARN money once a real Block ID is set.
 */
export const ADSGRAM_BLOCK_ID = "34922";

/** Gold granted each time a player watches a rewarded ad. */
export const AD_REWARD_GOLD = 150;
